module.exports = __webpack_public_path__ + "static/media/icon-error-black-exclamation-mark.a7ea0bd9.svg";